import { Col, Row } from "react-bootstrap";
import React, { Dispatch, SetStateAction, useEffect } from "react";
import { TypeKeHoach } from "../models/KeHoachModel";
import LabelRequired from "../../../../component/LabelRequired";
import TextField from "../../../../component/TextField";

interface Props {
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>;
  type: TypeKeHoach;
  dataKinhPhi: any;
  setDataKinhPhi: Dispatch<SetStateAction<any>>;
  isView?: boolean;
}

const DuDoanKinhPhi = (props: Props) => {
  const { isView, dataKinhPhi, setDataKinhPhi } = props;

  useEffect(() => {
    if (dataKinhPhi.totalBudget && dataKinhPhi.studentPayPercent) {
      const total = parseFloat(dataKinhPhi.totalBudget) || 0;
      const percent = parseFloat(dataKinhPhi.studentPayPercent) || 0;
      const calculated = (total * percent) / 100;

      setDataKinhPhi((prev: any) => ({
        ...prev,
        studentPayAmount: calculated.toString()
      }));
    }
  }, [dataKinhPhi.totalBudget, dataKinhPhi.studentPayPercent]);

  useEffect(() => {
    if (dataKinhPhi.totalBudget && dataKinhPhi.stateBudgetPercent) {
      const total = parseFloat(dataKinhPhi.totalBudget) || 0;
      const percent = parseFloat(dataKinhPhi.stateBudgetPercent) || 0;
      const calculated = (total * percent) / 100;

      setDataKinhPhi((prev: any) => ({
        ...prev,
        stateBudgetAmount: calculated.toString()
      }));
    }
  }, [dataKinhPhi.totalBudget, dataKinhPhi.stateBudgetPercent]);

  const handleChangeValueText = (field: string, value: any) => {
    setDataKinhPhi((prev: any) => ({
      ...prev,
      [field]: value
    }));
  };

  const formatCurrency = (value: string) => {
    if (!value) return '';
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    return num.toLocaleString('vi-VN');
  };

  return (
    <div className="spaces pb-10 mb-5">
      <div className="spaces  mt-2  title">
        <span className="text-title fw-bold fs-5 spaces mb-5 mt-20">
          Dự toán kinh phí
        </span>
      </div>
      <Row>
        <Col lg={3} className="spaces">
          <div className="spaces pt-10 min-w-135">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Tổng chi phí" />
            </div>
          </div>
        </Col>
        <Col lg={9} className="spaces">
          <TextField
            name="totalBudget"
            type="number"
            onChange={(e: any) => handleChangeValueText('totalBudget', e.target.value)}
            value={dataKinhPhi.totalBudget}
            disabled={isView}
          />
        </Col>

        {/* Học viên/đơn vị tuyến dưới trả */}
        <Col lg={3} className="spaces">
          <div className="spaces pt-10 min-w-195">
            <div className="spaces mt-1">
              <LabelRequired
                className="min-w-100px"
                label="% tiền từ học viên/đơn vị tuyến dưới trả"
              />
            </div>
          </div>
        </Col>
        <Col lg={4} className="spaces pt-8">
          <TextField
            name="studentPayPercent"
            type="number"
            onChange={(e: any) => handleChangeValueText('studentPayPercent', e.target.value)}
            value={dataKinhPhi.studentPayPercent}
            disabled={isView}
            min="0"
            max="100"
          />
        </Col>
        <Col lg={1} className="spaces">
          <div className="spaces pt-10 min-w-195">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Thành tiền" />
            </div>
          </div>
        </Col>
        <Col lg={4} className="spaces pt-8">
          <TextField
            name="studentPayAmount"
            type="text"
            value={formatCurrency(dataKinhPhi.studentPayAmount)}
            disabled={true}
          />
        </Col>

        {/* Ngân sách nhà nước trả */}
        <Col lg={3} className="spaces">
          <div className="spaces pt-10 min-w-195">
            <div className="spaces mt-1">
              <LabelRequired
                className="min-w-100px"
                label="% do ngân sách nhà nước trả"
              />
            </div>
          </div>
        </Col>
        <Col lg={4} className="spaces pt-8">
          <TextField
            name="stateBudgetPercent"
            type="number"
            onChange={(e: any) => handleChangeValueText('stateBudgetPercent', e.target.value)}
            value={dataKinhPhi.stateBudgetPercent}
            disabled={isView}
            min="0"
            max="100"
          />
        </Col>
        <Col lg={1} className="spaces">
          <div className="spaces pt-10 min-w-195">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Thành tiền" />
            </div>
          </div>
        </Col>
        <Col lg={4} className="spaces pt-8">
          <TextField
            name="stateBudgetAmount"
            type="text"
            value={formatCurrency(dataKinhPhi.stateBudgetAmount)}
            disabled={true}
          />
        </Col>
      </Row>
    </div>
  );
};

export default DuDoanKinhPhi;